import { useTranslation } from "react-i18next";

import { AvailabilityGate } from "@shared/components/AvailabilityGate/AvailabilityGate";
import { useSelfCheckoutFlow } from "@shared/selfCheckoutFlow/useSelfCheckoutFlow";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  onContinue?: (email: string, zipCode: string) => void;
  loading?: boolean;
  initialEmail?: string;
  initialZipCode?: string;
}

/**
 * Journey entry availability step — thin wrapper over the presentational
 * AvailabilityGate. Collects email + zip (fields from the journey flow
 * descriptor); the page runs Journey's own zip serviceability check
 * (CheckForJourneysAvailability), which is distinct from the direct-lab
 * state-restriction gate.
 */
const JourneyAvailabilityForm = ({
  onContinue,
  loading = false,
  initialEmail = "",
  initialZipCode = "",
}: Props) => {
  const { t } = useTranslation();
  const flow = useSelfCheckoutFlow("journey");

  return (
    <AvailabilityGate
      fields={flow.entryFields}
      copy={{
        title: t(l.journeyCheckout.availability.title),
        emailLabel: t(l.journeyCheckout.availability.emailLabel),
        zipCodeLabel: t(l.journeyCheckout.availability.zipCodeLabel),
        zipInvalidError: t(l.journeyCheckout.availability.errors.zipInvalid),
        locationNote: t(l.journeyCheckout.availability.locationNote),
        continueLabel: t(l.journeyCheckout.availability.continueButton),
        emailInvalidError: t(l.journeyCheckout.availability.errors.emailInvalid),
      }}
      onContinue={({ email, zipCode }) => onContinue?.(email, zipCode || "")}
      loading={loading}
      initialEmail={initialEmail}
      initialZipCode={initialZipCode}
    />
  );
};

export { JourneyAvailabilityForm };
